<div *ngIf="source_type == 'area'" class="source-type">


  <button class="header-icon mr-2" mat-mini-fab [ngClass]="{
  'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  'icons-background' :
  ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
}">
    <mat-icon (mouseover)="changeIconFill=false" (mouseleave)="changeIconFill=true"
      class="material-icons notranslate position-icon-1 defulat-icons-color" [ngClass]="{
  'material-symbols-outlined': (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
  'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
}">map</mat-icon>
  </button>

</div>

<div *ngIf="source_type == 'store'" class="source-type">


  <button class="header-icon mr-2" mat-mini-fab [ngClass]="{
    'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false  ,  'icons-background' :
    ( environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR && environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND ) , 'defult-background-icons' : !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
}">
    <mat-icon (mouseover)="changeIconFill=false" (mouseleave)="changeIconFill=true"
      class="material-icons notranslate position-icon-1 defulat-icons-color" [ngClass]="{
    'material-symbols-outlined':  (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
    'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
}">store</mat-icon>
  </button>


</div>


<div *ngIf="source_type == 'appleSvg'" class="source-svg-ios">
  <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
    y="0px" viewBox="0 0 22.773 22.773" style="enable-background:new 0 0 22.773 22.773;" xml:space="preserve">
    <g>
      <g>
        <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573
			c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
        <path
          d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334
			c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0
			c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019
			c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464
			c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648
			c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
      <g>
      </g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</div>


<div *ngIf="source_type == 'androidSvg'" class="source-svg-android">
  <svg enable-background="new 0 0 56.693 56.693" height="56.693px" id="Layer_1" version="1.1"
    viewBox="0 0 56.693 56.693" width="56.693px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <g>
      <path
        d="M35.021,8.568l0.547-0.819l0.537-0.808l1.209-1.813c0.148-0.223,0.088-0.523-0.133-0.672   c-0.225-0.149-0.525-0.089-0.674,0.135l-1.295,1.944l-0.545,0.817L34.114,8.18c-1.752-0.679-3.705-1.06-5.768-1.06   c-2.061,0-4.014,0.381-5.766,1.06L22.03,7.352l-0.545-0.817L20.188,4.59c-0.148-0.223-0.449-0.283-0.673-0.135   c-0.222,0.148-0.282,0.449-0.134,0.672l1.208,1.813l0.539,0.808l0.547,0.819c-4.115,1.916-6.898,5.546-6.898,9.701h27.142   C41.919,14.114,39.136,10.484,35.021,8.568z M22.532,14.391c-0.805,0-1.455-0.651-1.455-1.454s0.65-1.453,1.455-1.453   c0.803,0,1.453,0.65,1.453,1.453S23.335,14.391,22.532,14.391z M34.163,14.391c-0.803,0-1.453-0.651-1.453-1.454   s0.65-1.453,1.453-1.453c0.805,0,1.455,0.65,1.455,1.453S34.968,14.391,34.163,14.391z" />
      <path
        d="M14.986,20.208h-0.209v2.418v1.973v16.936c0,1.693,1.376,3.07,3.069,3.07h2.216c-0.074,0.256-0.116,0.527-0.116,0.807   v0.162v0.969v5.01c0,1.605,1.303,2.908,2.909,2.908s2.908-1.303,2.908-2.908v-5.01v-0.969v-0.162c0-0.279-0.043-0.551-0.115-0.807   h5.4c-0.074,0.256-0.115,0.527-0.115,0.807v0.162v0.969v5.01c0,1.605,1.303,2.908,2.908,2.908s2.908-1.303,2.908-2.908v-5.01   v-0.969v-0.162c0-0.279-0.041-0.551-0.115-0.807h2.215c1.693,0,3.07-1.377,3.07-3.07V24.599v-1.973v-2.418H41.71H14.986z" />
      <path
        d="M9.929,20.208c-1.606,0-2.908,1.301-2.908,2.909v12.439c0,1.605,1.302,2.908,2.908,2.908c1.605,0,2.908-1.303,2.908-2.908   V23.116C12.837,21.509,11.535,20.208,9.929,20.208z" />
      <path
        d="M46.767,20.208c-1.607,0-2.908,1.301-2.908,2.909v12.439c0,1.605,1.301,2.908,2.908,2.908c1.605,0,2.906-1.303,2.906-2.908   V23.116C49.673,21.509,48.372,20.208,46.767,20.208z" />
    </g>
  </svg>
</div>